import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

export function ProgressIndicator({ fields, scope }: ComponentProps) {
  const value = useBound<number>(fields.value as BoundValue, scope) ?? 0;
  const max   = useBound<number>(fields.max as BoundValue, scope) ?? 100;
  const variant = useBound<string>(fields.variant as BoundValue, scope) ?? "linear";
  const label = useBound<string>(fields.label as BoundValue, scope);

  const pct = Math.max(0, Math.min(100, (value / max) * 100));

  if (variant === "circular") {
    const r = 18;
    const c = 2 * Math.PI * r;
    return (
      <div className="a2-progress-circular">
        <svg width="48" height="48" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r={r} className="track" />
          <circle
            cx="24" cy="24" r={r}
            className="fill"
            strokeDasharray={c}
            strokeDashoffset={c * (1 - pct / 100)}
            transform="rotate(-90 24 24)"
          />
        </svg>
        {label && <span className="a2-progress-label">{label}</span>}
      </div>
    );
  }

  return (
    <div className="a2-progress-linear">
      {label && <div className="a2-progress-label">{label}</div>}
      <div className="a2-progress-track">
        <div className="a2-progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
